import type { CaseDefinition, NodeDefinition } from "../../domain/types/index.js";

const CASE_ICONS: Record<CaseDefinition["size"], string> = {
  small: "/icon-case-small.png",
  medium: "/icon-case-medium.png",
  large: "/icon-case-large.png",
  boss: "/icon-boss.png",
};

export function nodeIcon(node: NodeDefinition, spec: CaseDefinition | null): string {
  if (node.kind === "start") return "/icon-start.png";
  if (node.kind === "rest") return "/icon-rest.png";
  if (node.kind === "event") return "/icon-event.png";
  if (node.kind === "relic") return "/icon-relic-v2.png";
  return CASE_ICONS[spec?.size ?? "small"];
}

export function nodeAlt(node: NodeDefinition): string {
  if (node.kind === "start") return "開始地点";
  if (node.kind === "rest") return "休日";
  if (node.kind === "event") return "イベント";
  if (node.kind === "relic") return "基盤マス";
  return "PJ";
}
